/* eslint-disable import/no-anonymous-default-export */
export default {
  GET_PRODUCT: 'GET_PRODUCT',
};
